'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { ItineraryCard } from '~/components/ItineraryCard/src/ItineraryCard';
import { TRPC_SETTINGS } from '~/constants/trpc';
import { useIsTripUpdating } from '~/hooks/useIsTripUpdating';
import { useTripId } from '~/hooks/useTripId';
import { api } from '~/libs/api';
import { trackFunnelEvent } from '~/utils/funnelTracking';
import { useTripOverviewSummary } from '../hooks/useTripOverviewSummary';
import { alternativeLegTimeOptions, hasAlternativeLegTimes } from './alternativeLegTimes';
import { ChangeTravelTimesSheet } from './ChangeTravelTimesSheet';
type ChangeTravelTimesFieldProps = {
  itemId: number;
  startDate: string;
  origin: string;
  destination: string;
  departureTimeText: string | null;
  arrivalTimeText: string | null;
};
export const ChangeTravelTimesField = t0 => {
  const $ = _c(34);
  const {
    itemId,
    startDate,
    origin,
    destination,
    departureTimeText,
    arrivalTimeText
  } = t0;
  const t = useTranslations("journey");
  const tripId = useTripId();
  const [isOpen, setIsOpen] = useState(false);
  const {
    canEditTripSelections,
    isLiveChecking
  } = useTripOverviewSummary();
  const isTripUpdating = useIsTripUpdating();
  let t1;
  if ($[0] !== tripId) {
    t1 = {
      tripId
    };
    $[0] = tripId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!tripId && canEditTripSelections;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      ...TRPC_SETTINGS.QUERY_NO_REFETCH,
      enabled: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: times
  } = api.trip.getTransportTimes.useQuery(t1, t3);
  if (!canEditTripSelections) {
    return null;
  }
  let currentTime;
  let options;
  let t4;
  if ($[4] !== arrivalTimeText || $[5] !== departureTimeText || $[6] !== itemId || $[7] !== times) {
    options = alternativeLegTimeOptions(times, itemId);
    currentTime = departureTimeText && arrivalTimeText ? {
      departureTime: departureTimeText,
      arrivalTime: arrivalTimeText
    } : null;
    t4 = hasAlternativeLegTimes(options, currentTime);
    $[4] = arrivalTimeText;
    $[5] = departureTimeText;
    $[6] = itemId;
    $[7] = times;
    $[8] = currentTime;
    $[9] = options;
    $[10] = t4;
  } else {
    currentTime = $[8];
    options = $[9];
    t4 = $[10];
  }
  const canChange = t4;
  let t5;
  if ($[11] !== t) {
    t5 = t("overview_train_times_label");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== canChange || $[14] !== t) {
    t6 = canChange ? t("overview_train_times_change_prompt") : t("transport_train_times_only_option");
    $[13] = canChange;
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      trackFunnelEvent("trip_funnel_times_change");
      setIsOpen(true);
    };
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const t8 = !canChange || isTripUpdating || isLiveChecking;
  let t9;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t8) {
    t9 = <ItineraryCard.ChangeField label={t5} value={t6} onPress={t7} isDisabled={t8} isValueSubtext={true} />;
    $[17] = t5;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== canChange || $[22] !== currentTime || $[23] !== destination || $[24] !== isOpen || $[25] !== itemId || $[26] !== options || $[27] !== origin || $[28] !== startDate || $[29] !== tripId) {
    t10 = canChange && <ChangeTravelTimesSheet isOpen={isOpen} close={() => setIsOpen(false)} tripId={tripId} itemId={itemId} startDate={startDate} origin={origin} destination={destination} options={options} currentTime={currentTime} />;
    $[21] = canChange;
    $[22] = currentTime;
    $[23] = destination;
    $[24] = isOpen;
    $[25] = itemId;
    $[26] = options;
    $[27] = origin;
    $[28] = startDate;
    $[29] = tripId;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[31] = t10;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
};